import handleBanner from "./banner";
import handleButton from "./button";
import handleCartInlineBlock from "./cart-inline-block";
import handleDynamicText from "./dynamic-text";
import handleFilters from "./filters";
import handleInlineBlock from "./inline-block";
import handleSimilarInlineBlock from "./similar-inline-block";
import handleProductList from "./product-list";
import { HeliumAttributes } from "./types";
import { getProducts } from "./utils";
import handleTagBasedProducts from "./tag-based-products";
import { handleDescriptionBadgesStatic } from "./description-badges";
import handleCartGoals from "./cart-goals";
import handleProductItem from "./product-item";
import handleMemoryRecommendation from "./memory-recommendatation";
import { handleVariatSelector } from "./variant-selector";
import handleLowTicketRecommendation from "./low-ticket-recommendation";
import { handleBadge } from "./badge";
import { handleDescription } from "./ui-description";

let set = false;
export default async function UIScriptInit() {
  if (set) return;
  set = true;
  handleUiScript(true);
}
export function flagCheck(flag: string) {
  const featureflags = window.helium.brandData?.pro?.featureFlags;
  const bool =
    (typeof featureflags?.[flag] === "boolean" &&
      featureflags?.[flag] === true) ||
    typeof featureflags?.[flag] !== "boolean";
  console.log({ flag, bool });
  return bool;
}
let intervalAdded = false;

const heliumItems: Set<HeliumAttributes> = new Set([
  "cart",
  "cart-item",
  "collection-item",
  "product-item",
  "collection-list",
  "product-list",
  "cart-cta",
  "inline-block",
  "cart-inline-block",
  "banner",
  "dynamic-text",
  "button",
  "dynamic-block",
  "cart-goals",
  "tag-recommendations",
  "memory-recommendations",
  "variant-selector",
  "description-badges-static",
  "badge", // Add badge to heliumItems
  "ui-description",

  "cart",
  "cart-item",
  "collection-item",
  "product-item",
  "collection-list",
  "product-list",
  "cart-cta",
  "inline-block",
  "cart-inline-block",
  "banner",
  "dynamic-text",
  "button",
  "dynamic-block",
  "cart-goals",
  "tag-recommendations",
  "memory-recommendations",
  "variant-selector",
  "low-ticket-size-recommendation",
  "ui-description",
  "description-badges-static",
]);
export async function handleUiScript(isInit: boolean) {
  const elements = document.querySelectorAll<HTMLElement>("[data-helium-name]");
  const tasks: Promise<void>[] = [];

  if (isInit && !window.location.pathname.includes("products")) {
    if (flagCheck("because-viewed")) {
      if (!intervalAdded) {
        setInterval(handleProductItem.monitorLastViewedProduct, 1000);
        intervalAdded = true;
      }
    }
    flagCheck("inferred-filters") && handleFilters();
  }
  const localVariant = localStorage.getItem("helium-prev-variant");

  elements.forEach((element) => {
    const val = element.getAttribute("data-helium-name");
    if (EleHasListener(element)) return;
    EleListenerAdded(element);

    if (heliumItems.has(val as HeliumAttributes)) {
      switch (val) {
        case "inline-block":
          tasks.push(handleInlineBlock(element, window.helium.ui));
          break;
        case "variant-selector":
          break;
          try {
            tasks.push(handleVariatSelector(element, window.helium.ui));
          } catch (e) {
            console.log(e);
          }
          break;
        case "button":
          handleButton(element, window.helium.ui);
          break;

        case "cart-inline-block":
          tasks.push(handleCartInlineBlock(element, window.helium.ui));
          break;

        case "dynamic-text":
          handleDynamicText(element, window.helium.ui);
          break;

        case "banner":
          handleBanner(element, window.helium.ui);
          break;
        case "product-list":
          if (!flagCheck("product-list")) break;
          tasks.push(handleProductList(element));
          // handleFilters(element, window.helium.ui);
          break;
        case "product-item":
          if (!flagCheck("because-viewed")) break;
          handleProductItem.addEvent(element);
          handleSimilarInlineBlock(element, window.helium.ui);
          break;
        case "cart-goals":
          handleCartGoals(element);
          break;
        case "dynamic-block":
          //tasks.push(handleDynamicBlock(element));
          break;
        case "tag-recommendations":
          tasks.push(handleTagBasedProducts(element));
          break;
        case "low-ticket-size-recommendation":
          tasks.push(handleLowTicketRecommendation(element, window.helium.ui));
          break;
        case "memory-recommendations":
          tasks.push(handleMemoryRecommendation(element, window.helium.ui));
          break;

        case "description-badges-static":
          tasks.push(handleDescriptionBadgesStatic(element));
          break;

        case "badge": // Handle badge element
          tasks.push(handleBadge(element));
          break;
        case "ui-description": // Handle badge element
          tasks.push(handleDescription(element));
          break;
        default:
          console.log(`Unhandled helium item: ${val}`);
      }
    }
  });

  await Promise.all(
    tasks.map(async (task) => {
      try {
        await task;
      } catch (e) {
        console.warn("Error in task", e);
      }
    }),
  );
  document.body.style.visibility = "visible";
}

const listenerKey = "data-helium-listener";
function EleHasListener(ele: HTMLElement) {
  const listenerData = ele.getAttribute(listenerKey);
  if (listenerData) return true;
  return false;
}
function EleListenerAdded(ele: HTMLElement) {
  const listenerData = ele.setAttribute(listenerKey, "true");
}

async function handleDynamicBlock(element: HTMLElement) {
  //logic to get recently viewed handles
  let handles;
  const products = await getProducts(
    handles ?? [
      "clairemont-dress-vine-apparel",
      "satin-stripes-shirt-brown-and-beige-sh227brst",
      "cotton-colour-block-tee-black-and-white-knts084bkwh",
    ],
  );
  console.log("recently viewed products", products);
  window.helium.ui.renderRecentlyViewed(element, products);
}
